import './eta.sss';
import { S, SA, DC, RCL, ACL, RCLA, TEXT} from '../../Utilities';


export default class EtaSlider {
    constructor() {
        this.sliderEl = S('.top_slider');
        this.navList = [];
        this.currentIndex = 0;
        this.timer;
        this.delay = 8;

        if (this.sliderEl) {
            this.panel = S('.panels', this.sliderEl);
            this.panels = SA('article', this.panel);
            this.nav = DC('ul', 'slider_nav');
            this.createNav();
            this.switchPanel(0);
            this.sliderEl.appendChild(this.nav);
            this.autoRun();
        }
    }


    switchPanel(index, stop) {
        const total = this.panels.length;
        const next = (index + 1) > total - 1 ? 0 : (index + 1);
        RCLA(this.navList, 'current');
        ACL(this.navList[index], 'current');
        RCLA(this.panels, 'current');
        ACL(this.panels[index], 'current');
        this.currentIndex = index;
        this.btnRight.style.backgroundImage = this.panels[next].style.backgroundImage;
        if (stop) {
            clearInterval(this.timer);
        }
    }

    autoRun() {
        this.timer = setInterval(() => {
            const total = this.panels.length;
            this.currentIndex = this.currentIndex >= total - 1 ? 0 : this.currentIndex + 1;
            this.switchPanel(this.currentIndex);
        }, this.delay * 1000);
    }

    createNav() {

        this.arrowNav = DC('div', 'slider_nav_arrows');
        this.btnRight = DC('span', 'slider_nav_arrows_right');
        this.btnLeft = DC('span', 'slider_nav_arrows_left');
        this.btnRight.addEventListener('click', () => {
            const total = this.panels.length;
            this.currentIndex = this.currentIndex >= total - 1 ? 0 : this.currentIndex + 1;
            this.switchPanel(this.currentIndex, true);
        });
        this.btnLeft.addEventListener('click', () => {
            const total = this.panels.length;
            this.currentIndex = this.currentIndex < 1 ? total - 1 : this.currentIndex - 1;
            this.switchPanel(this.currentIndex, true);
        });
        this.arrowNav.appendChild(this.btnLeft);
        this.arrowNav.appendChild(this.btnRight);
        this.sliderEl.appendChild(this.arrowNav);


        [...this.panels].forEach((panel, i) => {
            const panEl = DC('li', 'slider_nav_item');
            const panImg = DC('span', 'slider_nav_item_img');
            panImg.style.backgroundImage = panel.style.backgroundImage;
            panEl.appendChild(panImg);
            this.nav.appendChild(panEl);
            this.navList.push(panEl);
            panEl.addEventListener('click', e => this.switchPanel(i, true));
        });
    }
}